exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scoped-textarea-class[data-v-ecae59b6]{height:100%;width:100%}.scoped-fix-height-1-1[data-v-ecae59b6]{margin-top:1%;height:99%}.scoped-fix-height-1-2[data-v-ecae59b6]{height:48%;margin-top:1%}", ""]);

// exports
